export default function() {
    return {
        termsOfUse: {
            content: '',
            version: 0
        },
        agencyId: null,
        termsSuccess: false,
        termsError: false,
        customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }]]
    }
}
